import React from 'react'
import { GetServerSideProps, NextPage } from 'next'
import { getServerSidePropsWrapper } from 'lib/routing/nextPageUtils'
import AffiliateHeader from 'components/layout/AffiliateHeader'
import { MinimalLayout } from 'shared/layout/MinimalLayout'
import { Affiliate } from 'services/ContentfulService/models/affiliate'
import { getSeoMetaObject, MetaTagsInterface } from 'lib/routing/MetaTags'
import { getAffiliateBySlug } from 'services/ContentfulService/hooks/affiliates'
import MultiProductWidget from 'components/vendor/MultiProductWidget/MultiProductWidget'
import { EMBED_PRODUCTS } from 'parameters/embeds'
import ExplorePageLayout from 'experiences/explore/simpleExplorePages/layouts/ExplorePageLayout'
import { LoanAdvertisingCopy } from 'components/domain/search/offers/loans/utils/constants'
import { AffiliateFooter } from 'shared/layout/Footer'

interface Props {
	affiliate: Affiliate
	metaTags: MetaTagsInterface
}

const TaboolaPage: NextPage<Props> = ({ metaTags, affiliate }): JSX.Element => (
	<MinimalLayout metaTags={metaTags}>
		<AffiliateHeader
			partnerUrl={affiliate.partner.website}
			partnershipText={affiliate.partnershipLanguage}
			partnerLogo={affiliate.partner.logo.url}
			headerStyle={affiliate.headerType || 'fiona_only'}
		/>
		<ExplorePageLayout
			articles={[]}
			title={'Get Matched With Personal Loan Offers In Less Than 60 Seconds'}
			description={`LOANS FROM $1,000 - $250,000 | LOAN TERMS 24 - 84 MONTHS | APR FROM ${LoanAdvertisingCopy.LowestAPR}`}
			background="/images/explore-illustration.svg"
		>
			<MultiProductWidget
				product={EMBED_PRODUCTS.LOAN}
				partner={affiliate.partner.slug}
				step={'application'}
				override={affiliate.embedParams}
				isExplorePage
			/>
		</ExplorePageLayout>
		<AffiliateFooter />
	</MinimalLayout>
)

export const getServerSideProps: GetServerSideProps = getServerSidePropsWrapper<Props>(async ctx => {
	const slug = 'tab-loans'
	console.log(ctx.query)
	const affiliate = await getAffiliateBySlug(slug)
	const metaTags = getSeoMetaObject(ctx.resolvedUrl, undefined, {
		description: 'Compare loan offers with Fiona',
		title: 'Loan Search with Fiona'
	})

	return { affiliate, metaTags }
})

export default TaboolaPage
